/* eslint-disable */
import { db } from "../firebase";
import {
  collection,
  addDoc,
  updateDoc,
  getDocs,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { useTranslation } from "react-i18next";

export const createNotification = async (userId, message, type, ownerModel) => {
  const { t } = useTranslation();
  try {
    await addDoc(collection(db, "notifications"), {
      userId: userId,
      ownerModel: ownerModel,
      message: message,
      type: type,
      read: false,
      timestamp: serverTimestamp(),
    });
    // console.log("Notification added!");
  } catch (error) {
    console.error("Error adding notification:", error);
  }
};

export const createProductNotification = async (
  userId,
  message,
  type,
  ownerModel,
  productId
) => {
  if (!userId) {
    console.warn("Missing userId. Notification not sent.");
    return;
  }

  try {
    await addDoc(collection(db, "notifications"), {
      userId,
      ownerModel,
      productId,
      message,
      type,
      read: false,
      timestamp: serverTimestamp(),
    });
    // console.log("Notification added!");
  } catch (error) {
    console.error("Error adding notification:", error);
  }
};

export const sendNotificationFromAdmin = async () => {
  try {
    const staticMessage = "تم إرسال إشعار جديد من الإدارة";

    const notificationRef = await addDoc(collection(db, "notifications"), {
      message: staticMessage,
      ownerModel: "admin",
      timestamp: serverTimestamp(),
      type: "alert_admin",
      readBy: {}, // Initialize readBy as an empty object
    });

    // console.log("تم إنشاء الإشعار:", notificationRef.id);
  } catch (error) {
    console.error("خطأ في إرسال الإشعار:", error);
  }
};
